import Axios from '@/axios'


// 更新支付宝门店申请单状态
// 接口权限名：web:zfbStore:updateOrderStatus
export const ZfbStoreUpdateOrderStatus = id => {
  return Axios({
    url: `/device-manager/web-api/zfb-store/update_order_status/${id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 创建支付宝门店
// 接口权限名：web:zfbStore:create
export const ZfbStoreCreate = data => {
  return Axios({
    url: `/device-manager/web-api/zfb-store/create`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 修改支付宝门店
// 接口权限名：web:zfbStore:update
export const ZfbStoreUpdate = data => {
  return Axios({
    url: `/device-manager/web-api/zfb-store/update`,
    method: 'POST',
    type: 'json',
    data
  })
}

